import { ModalProps } from 'antd';
import GuideDialog from './NewbieGuideDialog';
import { useTranslate } from '@tolgee/react';

export interface MercadoShopDialogProps extends ModalProps {
  isConfigService: boolean;
  onConfigService: (e: any) => void;
}

const MercadoAuthShopDialog = (props: MercadoShopDialogProps) => {
  const { t } = useTranslate();

  return (
    <GuideDialog
      defaultPlatform="mercado"
      defaultTitle={t('添加Mercado店铺')}
      {...props}
      closable
      maskClosable={false}
    />
  );
};

export default MercadoAuthShopDialog;
